import { Cookie } from 'ng2-cookies';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'environments/environment';
import Pusher from 'pusher-js';

export interface PusherEvent {
    name: string;
    data: any;
}

type PusherBindCallback = (name: string, data: any) => void;

type PusherConnectionState = 'initialized' | 'connecting' | 'connected' | 'unavailable' | 'failed' | 'disconnected';

interface ConnectionChangeStates {
    previous: PusherConnectionState;
    current: PusherConnectionState;
}

interface PusherConnection {
    state: PusherConnectionState;
    bind: (eventType: string, callback: (states: ConnectionChangeStates) => void) => void;
}

@Injectable()
export class PusherService {

    private _events = new Subject<PusherEvent>();
    private pusher: any;

    constructor() {
        this.pusher = new Pusher(environment.PUSHER_APP_KEY, {
            auth: {
                headers: {
                    Authorization: 'Bearer ' + Cookie.get('auth_token')
                }
            },
            authEndpoint: environment.API_URL + '/authorization/pusher'
        });

        this.pusher.bind_global((name, data) => {
            this._events.next({name, data});
        });
    }

    get events(): Observable<PusherEvent> {
        return this._events.asObservable();
    }

    subscribe(channelName: string) {
        return this.subscribeRaw(`${environment.environment}-${channelName}`);
    }

    unsubscribe(channelName: string) {
        return this.unsubscribeRaw(`${environment.environment}-${channelName}`);
    }

    subscribeRaw(channelName: string) {
      const channel = this.pusher.channel(channelName);
      if (channel) {
        return channel;
      }
      return this.pusher.subscribe(channelName);
    }

    unsubscribeRaw(channelName: string) {
      const channel = this.pusher.channel(channelName);
      if (!channel) {
        return false;
      }
      this.pusher.unsubscribe(channelName);
      return true;
    }

    unsubscribeAll(): void {
      this.pusher.disconnect();
    }
}
